import Util from './util';
import Template from './template';

const cls = Util.cls;
const getBEMSelect = (el, mod) => Util.getBEM('select', el, mod);
const config = {
    sel: {
        // selectors used in js
        base: getBEMSelect(),
        disabled: getBEMSelect(null, 'disabled'),
        readonly: getBEMSelect(null, 'readonly'),

        input: getBEMSelect('input'),
        input_open: getBEMSelect('input', 'open'),
        val: getBEMSelect('val'),
        items: getBEMSelect('items'),
        items_open: getBEMSelect('items', 'open'),
        item: getBEMSelect('item'),

        // selectors only used in html
        widget: getBEMSelect('widget'),
        field: getBEMSelect('field'),
        icon: getBEMSelect('icon')

    },
    globalListenersRegistered: false,
    instances: []
};
config.itemId = 'select-id';
config.itemIdAttr = 'data-' + config.itemId;


// add templates
Template.add('select__widget', `
    <div class="${cls(config.sel.widget)}">
        <div class="${cls(config.sel.field)}">
            <div class="${cls(config.sel.val)}"></div>
            <div class="${cls(config.sel.icon)} lnr lnr-chevron-down"></div>
        </div>
        <div class="${cls(config.sel.items)}">{{items}}</div>
    </div>
`);
Template.add('select__item',
    `<div class="${cls(config.sel.item)}" ${config.itemIdAttr}="{{index}}">
        {{label}}
    </div>`);

Select.autoDiscover = true;

function Select(el) {
    const self = this;
    let $el = $(el);

    // assert el is a valid DOM Element
    if (!el || !$el || !$el.length) throw new Error('Please provide a valid DOM Element');

    // assert el is a valid base element
    const isBaseEl = ($el) => $el.hasClass(cls(config.sel.base));
    if (!isBaseEl($el)) {
        $el = $el.parent();
        if (!isBaseEl($el)) throw new Error(`Please provide the base element or select as parameter & use the default DOM structure`);
    }

    // assert el is a single base element
    self.el = getNodesBeforeFill($el);
    if (self.el.this.length > 1) throw new Error(`"${$el}" is not a single element. Please create a dedicated select for every element`);

    self.isOpen = false;

    self._init();
}

Select.prototype._init = function () {
    const self = this;

    let html = '';

    // add options to custom select list
    self.el.option.each(function (index, el) {
        const $el = $(el);
        $el.attr(config.itemIdAttr, index);

        html += Template.fill('select__item', {
            img: $el.data('img'),
            index,
            label: $el.text()
        });
    });
    html = Template.fill('select__widget', {items: html});
    self.el.this.append(html);

    getNodesAfterFill(self.el);

    // set initial option
    let selected = self.el.option.filter('[selected]'),
        val = selected.length ? selected.data(config.itemId) : 0;
    self.setVal(val);

    // add click listeners
    // ..select open (close registered in global listeners)
    self.el.field.not(cls(config.sel.item)).on('click', self.onOpen.bind(self));
    // ..custom items
    self.el.item.on('click', self.onSelect.bind(self));

    // add to instances
    config.instances.push(self);
    // register global listeners if not already done
    if (!config.globalListenersRegistered) registerGlobalListeners();
};

// ---------- CALLBACKS ----------

Select.prototype.onOpen = function (ev) {
    const self = this;

    if (self.el.this.hasClass(cls(config.sel.disabled))) return;
    if (self.el.this.hasClass(cls(config.sel.readonly))) return;
    ev.stopPropagation();

    // close input if already open
    if (self.isOpen) return self.onClose();

    $(config.sel.items_open).trigger('click');

    self.el.input.addClass(cls(config.sel.input_open));
    self.el.items.addClass(cls(config.sel.items_open));
    self.isOpen = true;
};

Select.prototype.onClose = function () {
    const self = this;

    // don't close if select is already closed
    if (!self.isOpen) return;

    self.el.input.removeClass(cls(config.sel.input_open));
    self.el.items.removeClass(cls(config.sel.items_open));
    self.isOpen = false;
};

Select.prototype.onSelect = function (ev) {
    const self = this;
    self.setVal($(ev.currentTarget).data(config.itemId));
};

// ---------- INSTANCE HELPER ----------
Select.prototype.setVal = function (val) {
    const self = this;
    let selectedOption = self.el.item.filter(`[${config.itemIdAttr}="${val}"]`),
        html = selectedOption.html();

    selectedOption.prop('selected', true);
    self.el.val.html(html);
    self.el.input.change();
};


// ---------- STATIC HELPER ----------

function getNodesBeforeFill(domEl) {
    const getEl = (sel) => $(el.this.find(sel));
    let el = {this: $(domEl)};
    el.input = getEl(config.sel.input);
    el.option = el.input.children();

    return el;
}

function getNodesAfterFill(el) {
    const getEl = (sel) => $(el.this.find(sel));

    ['field', 'val', 'items', 'item'].forEach((field) => {
        el[field] = getEl(config.sel[field]);
    });
}

function registerGlobalListeners() {
    if (config.globalListenersRegistered) return;

    $(document).on('click', () => {
        config.instances.forEach((inst) => inst.onClose());
    });
}

Select._autoDiscover = () => {
    $(config.sel.base).each(function () {
        new Select(this);
    })
};


// ---------- DOCUMENT READY ----------
$(() => {
    //
    if (Select.autoDiscover) {
        Select._autoDiscover();
    }
});

export default Select;